const ANSWERS = [
  'No', 'Not today', 'It is decidedly so', 'Without a doubt', 'Yes definitely',
  'You may rely on it', 'As I see it yes', 'Cats may be involved', 'Most likely',
  'Outlook good', 'Signs point to yes', 'Reply hazy try again', 'Ask again later',
  'Better not tell you now', 'Cannot predict now', 'Concentrate and ask again',
  'Don\'t count on it', 'My reply is no', 'My sources say no', 'Outlook not so good',
  'Very doubtful', '42'
  ];

module.exports = ANSWERS;


// WEBPACK FOOTER //
// ./src/ANSWERS.js